{
	"Features": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"action": {
					"translations": {},
					"value": "action01"
				}
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"action": {
					"translations": {},
					"value": "action02"
				}
			}
		},
		"action01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "الهاتف: (916) 715-0890",
						"en": "tel:(916) 715-0890",
						"en-GB": "tel:(916) 715-0890",
						"en-US": "tel:(916) 715-0890",
						"es": "tel:(916) 715-0890",
						"es-419": "tel:(916) 715-0890",
						"es-ES": "tel:(916) 715-0890",
						"he": "טלפון: (916) 715-0890",
						"it": "tel:(916) 715-0890",
						"pl": "tel.: (916) 715-0890",
						"sw": "simu:(916) 715-0890",
						"tl": "telepono:(916) 715-0890",
						"vi": "điện thoại: (916) 715-0890",
						"zh": "电话：(916) 715-0890"
					},
					"value": "tel:(916) 715-0890"
				},
				"label": {
					"translations": {
						"ar": "اتصل الآن",
						"en": "Call Now",
						"en-GB": "Call Now",
						"en-US": "Call Now",
						"es": "Llama ahora",
						"es-419": "Llama ahora",
						"es-ES": "Llama ahora",
						"he": "התקשרו עכשיו",
						"it": "Chiama ora",
						"pl": "Zadzwoń teraz",
						"sw": "Piga simu Sasa",
						"tl": "Tumawag Ngayon",
						"vi": "Gọi ngay",
						"zh": "立即致电"
					},
					"value": "Call Now"
				}
			}
		},
		"action02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"ar": "https://calendly.com/amberbellante/new-meeting",
						"en": "https://calendly.com/amberbellante/new-meeting",
						"en-GB": "https://calendly.com/amberbellante/new-meeting",
						"en-US": "https://calendly.com/amberbellante/new-meeting",
						"es": "https://calendly.com/amberbellante/new-meeting",
						"es-419": "https://calendly.com/amberbellante/new-meeting",
						"es-ES": "https://calendly.com/amberbellante/new-meeting",
						"he": "https://calendly.com/amberbellante/new-meeting",
						"it": "https://calendly.com/amberbellante/new-meeting",
						"pl": "https://calendly.com/amberbellante/nowe-spotkanie",
						"sw": "https://calendly.com/amberbellante/new-meeting",
						"tl": "https://calendly.com/amberbellante/new-meeting",
						"vi": "https://calendly.com/amberbellante/new-meeting",
						"zh": "https://calendly.com/amberbellante/new-meeting"
					},
					"value": "https://calendly.com/amberbellante/new-meeting"
				},
				"label": {
					"translations": {
						"ar": "حدد موعدًا لاستشارة مجانية",
						"en": "Schedule a Free Consultation",
						"en-GB": "Schedule a Free Consultation",
						"en-US": "Schedule a Free Consultation",
						"es": "Solicite una consulta gratuita.",
						"es-419": "Solicite una consulta gratuita.",
						"es-ES": "Solicite una consulta gratuita.",
						"he": "קבע פגישת ייעוץ ללא תשלום",
						"it": "Prenota una consulenza gratuita",
						"pl": "Zaplanuj bezpłatną konsultację",
						"sw": "Panga Mashauriano ya Bure",
						"tl": "Mag-iskedyul ng Libreng Konsultasyon",
						"vi": "Đặt lịch tư vấn miễn phí",
						"zh": "预约免费咨询"
					},
					"value": "Schedule a Free Consultation"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"action01Class": {
					"translations": {},
					"value": "btn btn-primary btn-lg w-80"
				},
				"action02Class": {
					"translations": {},
					"value": "btn btn-primary btn-lg w-80"
				},
				"contentClass": {
					"translations": {},
					"value": "my-12"
				}
			}
		},
		"index": 0,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "04"
		}
	},
	"Form": {
		"Question 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"ar": "1",
						"en": "1",
						"en-GB": "1",
						"en-US": "1",
						"es": "1",
						"es-419": "1",
						"es-ES": "1",
						"he": "1",
						"it": "1",
						"pl": "1",
						"sw": "1",
						"tl": "1",
						"vi": "1",
						"zh": "1"
					},
					"value": "1"
				},
				"heading": {
					"translations": {
						"ar": "الاسم الأول",
						"en": "First Name",
						"en-GB": "First Name",
						"en-US": "First Name",
						"es": "Nombre de pila",
						"es-419": "Nombre de pila",
						"es-ES": "Nombre de pila",
						"he": "שֵׁם פְּרַטִי",
						"it": "Nome di battesimo",
						"pl": "Imię",
						"sw": "Jina la Kwanza",
						"tl": "Pangalan",
						"vi": "Tên",
						"zh": "名"
					},
					"value": "First Name"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "الرجاء إدخال اسمك",
						"en": "Please enter your Name",
						"en-GB": "Please enter your Name",
						"en-US": "Please enter your Name",
						"es": "Por favor ingrese su nombre",
						"es-419": "Por favor ingrese su nombre",
						"es-ES": "Por favor ingrese su nombre",
						"he": "אנא הזן את שמך",
						"it": "Inserisci il tuo nome",
						"pl": "Proszę podać swoje imię",
						"sw": "Tafadhali ingiza Jina lako",
						"tl": "Pakilagay ang iyong Pangalan",
						"vi": "Vui lòng nhập tên của bạn",
						"zh": "请输入您的姓名"
					},
					"value": "Please enter your Name"
				},
				"label": {
					"translations": {
						"ar": "الاسم الأول",
						"en": "First Name",
						"en-GB": "First Name",
						"en-US": "First Name",
						"es": "Nombre de pila",
						"es-419": "Nombre de pila",
						"es-ES": "Nombre de pila",
						"he": "שֵׁם פְּרַטִי",
						"it": "Nome di battesimo",
						"pl": "Imię",
						"sw": "Jina la Kwanza",
						"tl": "Pangalan",
						"vi": "Tên",
						"zh": "名"
					},
					"value": "First Name"
				},
				"required": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"ar": "نص",
						"en": "text",
						"en-GB": "text",
						"en-US": "text",
						"es": "texto",
						"es-419": "texto",
						"es-ES": "texto",
						"he": "טֶקסט",
						"it": "testo",
						"pl": "tekst",
						"sw": "maandishi",
						"tl": "teksto",
						"vi": "chữ",
						"zh": "文本"
					},
					"value": "text"
				}
			}
		},
		"Question 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"ar": "2",
						"en": "2",
						"en-GB": "2",
						"en-US": "2",
						"es": "2",
						"es-419": "2",
						"es-ES": "2",
						"he": "2",
						"it": "2",
						"pl": "2",
						"sw": "2",
						"tl": "2",
						"vi": "2",
						"zh": "2"
					},
					"value": "1"
				},
				"heading": {
					"translations": {
						"ar": "اسم العائلة",
						"en": "Last Name",
						"en-GB": "Last Name",
						"en-US": "Last Name",
						"es": "Apellido",
						"es-419": "Apellido",
						"es-ES": "Apellido",
						"he": "שֵׁם מִשׁפָּחָה",
						"it": "Cognome",
						"pl": "Nazwisko",
						"sw": "Jina la Ukoo",
						"tl": "Apelyido",
						"vi": "Họ",
						"zh": "姓"
					},
					"value": "Last Name"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "الرجاء إدخال اسم عائلتك",
						"en": "Please enter you last name",
						"en-GB": "Please enter you last name",
						"en-US": "Please enter you last name",
						"es": "Por favor, introduzca su apellido",
						"es-419": "Por favor, introduzca su apellido",
						"es-ES": "Por favor, introduzca su apellido",
						"he": "אנא הזן את שם המשפחה שלך",
						"it": "Inserisci il tuo cognome",
						"pl": "Proszę podać swoje nazwisko",
						"sw": "Tafadhali ingiza jina lako la ukoo",
						"tl": "Pakilagay ang iyong apelyido",
						"vi": "Vui lòng nhập họ của bạn",
						"zh": "请输入您的姓氏"
					},
					"value": "Please enter you last name"
				},
				"label": {
					"translations": {
						"ar": "اسم العائلة",
						"en": "Last Name",
						"en-GB": "Last Name",
						"en-US": "Last Name",
						"es": "Apellido",
						"es-419": "Apellido",
						"es-ES": "Apellido",
						"he": "שֵׁם מִשׁפָּחָה",
						"it": "Cognome",
						"pl": "Nazwisko",
						"sw": "Jina la Ukoo",
						"tl": "Apelyido",
						"vi": "Họ",
						"zh": "姓"
					},
					"value": "Last Name"
				},
				"required": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"ar": "نص",
						"en": "text",
						"en-GB": "text",
						"en-US": "text",
						"es": "texto",
						"es-419": "texto",
						"es-ES": "texto",
						"he": "טֶקסט",
						"it": "testo",
						"pl": "tekst",
						"sw": "maandishi",
						"tl": "teksto",
						"vi": "chữ",
						"zh": "文本"
					},
					"value": "text"
				}
			}
		},
		"Question 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {
						"ar": "عنوان البريد الإلكتروني",
						"en": "Email Address",
						"en-GB": "Email Address",
						"en-US": "Email Address",
						"es": "Dirección de correo electrónico",
						"es-419": "Dirección de correo electrónico",
						"es-ES": "Dirección de correo electrónico",
						"he": "כתובת דוא\"ל",
						"it": "Indirizzo e-mail",
						"pl": "Adres e-mail",
						"sw": "Anwani ya Barua Pepe",
						"tl": "Email Address",
						"vi": "Địa chỉ email",
						"zh": "电子邮件"
					},
					"value": "Email Address"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "يرجى إدخال عنوان بريد إلكتروني صالح",
						"en": "Please enter a valid email address",
						"en-GB": "Please enter a valid email address",
						"en-US": "Please enter a valid email address",
						"es": "Por favor, introduce una dirección de correo electrónico válida",
						"es-419": "Por favor, introduce una dirección de correo electrónico válida",
						"es-ES": "Por favor, introduce una dirección de correo electrónico válida",
						"he": "אנא הזן כתובת דוא\"ל תקפה",
						"it": "Si prega di inserire un indirizzo email valido",
						"pl": "Proszę podać prawidłowy adres e-mail",
						"sw": "Tafadhali weka anwani halali ya barua pepe",
						"tl": "Mangyaring maglagay ng wastong email address",
						"vi": "Vui lòng nhập địa chỉ email hợp lệ.",
						"zh": "请输入有效的电子邮件地址"
					},
					"value": "Please enter a valid email address"
				},
				"label": {
					"translations": {
						"ar": "عنوان البريد الإلكتروني",
						"en": "Email Address",
						"en-GB": "Email Address",
						"en-US": "Email Address",
						"es": "Dirección de correo electrónico",
						"es-419": "Dirección de correo electrónico",
						"es-ES": "Dirección de correo electrónico",
						"he": "כתובת דוא\"ל",
						"it": "Indirizzo e-mail",
						"pl": "Adres e-mail",
						"sw": "Anwani ya Barua Pepe",
						"tl": "Email Address",
						"vi": "Địa chỉ email",
						"zh": "电子邮件"
					},
					"value": "Email Address"
				},
				"required": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"ar": "بريد إلكتروني",
						"en": "email",
						"en-GB": "email",
						"en-US": "email",
						"es": "correo electrónico",
						"es-419": "correo electrónico",
						"es-ES": "correo electrónico",
						"he": "אֶלֶקטרוֹנִי",
						"it": "e-mail",
						"pl": "e-mail",
						"sw": "barua pepe",
						"tl": "email",
						"vi": "e-mail",
						"zh": "电子邮件"
					},
					"value": "email"
				}
			}
		},
		"Question 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {
						"ar": "رقم التليفون",
						"en": "Phone Number",
						"en-GB": "Phone Number",
						"en-US": "Phone Number",
						"es": "Número de teléfono",
						"es-419": "Número de teléfono",
						"es-ES": "Número de teléfono",
						"he": "מספר טלפון",
						"it": "Numero di telefono",
						"pl": "Numer telefonu",
						"sw": "Nambari ya Simu",
						"tl": "Numero ng Telepono",
						"vi": "Số điện thoại",
						"zh": "电话号码"
					},
					"value": "Phone Number"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "الرجاء إدخال رقم هاتف صحيح",
						"en": "Please Enter a valid phone number",
						"en-GB": "Please Enter a valid phone number",
						"en-US": "Please Enter a valid phone number",
						"es": "Por favor, introduzca un número de teléfono válido",
						"es-419": "Por favor, introduzca un número de teléfono válido",
						"es-ES": "Por favor, introduzca un número de teléfono válido",
						"he": "אנא הזן מספר טלפון תקין",
						"it": "Inserisci un numero di telefono valido",
						"pl": "Proszę podać prawidłowy numer telefonu",
						"sw": "Tafadhali Ingiza nambari halali ya simu",
						"tl": "Mangyaring maglagay ng wastong numero ng telepono",
						"vi": "Vui lòng nhập số điện thoại hợp lệ.",
						"zh": "请输入有效的电话号码"
					},
					"value": "Please Enter a valid phone number"
				},
				"label": {
					"translations": {
						"ar": "رقم التليفون",
						"en": "Phone Number",
						"en-GB": "Phone Number",
						"en-US": "Phone Number",
						"es": "Número de teléfono",
						"es-419": "Número de teléfono",
						"es-ES": "Número de teléfono",
						"he": "מספר טלפון",
						"it": "Numero di telefono",
						"pl": "Numer telefonu",
						"sw": "Nambari ya Simu",
						"tl": "Numero ng Telepono",
						"vi": "Số điện thoại",
						"zh": "电话号码"
					},
					"value": "Phone Number"
				},
				"type": {
					"translations": {
						"ar": "هاتف",
						"en": "tel",
						"en-GB": "tel",
						"en-US": "tel",
						"es": "teléfono",
						"es-419": "teléfono",
						"es-ES": "teléfono",
						"he": "טלפון",
						"it": "telefono",
						"pl": "telefon",
						"sw": "simu",
						"tl": "telepono",
						"vi": "điện thoại",
						"zh": "电话"
					},
					"value": "tel"
				}
			}
		},
		"Question 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"ar": "2",
						"en": "2",
						"en-GB": "2",
						"en-US": "2",
						"es": "2",
						"es-419": "2",
						"es-ES": "2",
						"he": "2",
						"it": "2",
						"pl": "2",
						"sw": "2",
						"tl": "2",
						"vi": "2",
						"zh": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"ar": "رسالتك (اختياري)",
						"en": "Your message (optional)",
						"en-GB": "Your message (optional)",
						"en-US": "Your message (optional)",
						"es": "Tu mensaje (opcional)",
						"es-419": "Tu mensaje (opcional)",
						"es-ES": "Tu mensaje (opcional)",
						"he": "ההודעה שלך (אופציונלי)",
						"it": "Il tuo messaggio (facoltativo)",
						"pl": "Twoja wiadomość (opcjonalnie)",
						"sw": "Ujumbe wako (si lazima)",
						"tl": "Ang iyong mensahe (opsyonal)",
						"vi": "Lời nhắn của bạn (tùy chọn)",
						"zh": "您的留言（可选）"
					},
					"value": "Your message (optional)"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"label": {
					"translations": {
						"ar": "رسالة",
						"en": "Message",
						"en-GB": "Message",
						"en-US": "Message",
						"es": "Mensaje",
						"es-419": "Mensaje",
						"es-ES": "Mensaje",
						"he": "הוֹדָעָה",
						"it": "Messaggio",
						"pl": "Wiadomość",
						"sw": "Ujumbe",
						"tl": "Mensahe",
						"vi": "Tin nhắn",
						"zh": "信息"
					},
					"value": "Message"
				},
				"type": {
					"translations": {
						"ar": "منطقة نصية",
						"en": "textarea",
						"en-GB": "textarea",
						"en-US": "textarea",
						"es": "área de texto",
						"es-419": "área de texto",
						"es-ES": "área de texto",
						"he": "אזור טקסט",
						"it": "area di testo",
						"pl": "obszar tekstowy",
						"sw": "eneo la maandishi",
						"tl": "lugar ng teksto",
						"vi": "vùng văn bản",
						"zh": "文本区域"
					},
					"value": "textarea"
				}
			}
		},
		"Question 06": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"ar": "2",
						"en": "2",
						"en-GB": "2",
						"en-US": "2",
						"es": "2",
						"es-419": "2",
						"es-ES": "2",
						"he": "2",
						"it": "2",
						"pl": "2",
						"sw": "2",
						"tl": "2",
						"vi": "2",
						"zh": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"ar": "أوافق على تلقي الرسائل النصية من مكتب المحامية آمبر بيلانتي",
						"en": "I agree to accept text messages from The Law Offices of Amber Bellante",
						"en-GB": "I agree to accept text messages from The Law Offices of Amber Bellante",
						"en-US": "I agree to accept text messages from The Law Offices of Amber Bellante",
						"es": "Acepto recibir mensajes de texto de The Law Offices of Amber Bellante",
						"es-419": "Acepto recibir mensajes de texto de The Law Offices of Amber Bellante",
						"es-ES": "Acepto recibir mensajes de texto de The Law Offices of Amber Bellante",
						"he": "אני מסכים/ה לקבל הודעות טקסט ממשרד עורכי הדין של אמבר בלנטה",
						"it": "Accetto di ricevere messaggi di testo da The Law Offices of Amber Bellante",
						"pl": "Zgadzam się na otrzymywanie wiadomości tekstowych od Kancelarii Adwokackiej Amber Bellante",
						"sw": "Nakubali kupokea ujumbe mfupi kutoka Ofisi za Sheria za Amber Bellante",
						"tl": "Sumasang-ayon akong tumanggap ng mga text message mula sa The Law Offices of Amber Bellante",
						"vi": "Tôi đồng ý nhận tin nhắn văn bản từ Văn phòng Luật sư Amber Bellante.",
						"zh": "我同意接收来自 Amber Bellante 律师事务所的短信。"
					},
					"value": "I agree to accept text messages from The Law Offices of Amber Bellante"
				},
				"hideLabel": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"invalidMessage": {
					"translations": {
						"ar": "يجب عليك الموافقة على تلقي الرسائل النصية",
						"en": "You must consent to agree to receive text messages",
						"en-GB": "You must consent to agree to receive text messages",
						"en-US": "You must consent to agree to receive text messages",
						"es": "Debes dar tu consentimiento para aceptar recibir mensajes de texto.",
						"es-419": "Debes dar tu consentimiento para aceptar recibir mensajes de texto.",
						"es-ES": "Debes dar tu consentimiento para aceptar recibir mensajes de texto.",
						"he": "עליך להסכים לקבל הודעות טקסט",
						"it": "Devi acconsentire per accettare di ricevere messaggi di testo",
						"pl": "Aby wyrazić zgodę na otrzymywanie wiadomości tekstowych, musisz wyrazić zgodę",
						"sw": "Lazima ukubali kupokea ujumbe mfupi",
						"tl": "Dapat kang sumang-ayon na makatanggap ng mga text message",
						"vi": "Bạn phải đồng ý nhận tin nhắn văn bản.",
						"zh": "您必须同意接收短信"
					},
					"value": "You must consent to agree to receive text messages"
				},
				"label": {
					"translations": {
						"ar": "موافقة",
						"en": "Consent",
						"en-GB": "Consent",
						"en-US": "Consent",
						"es": "Consentir",
						"es-419": "Consentir",
						"es-ES": "Consentir",
						"he": "הַסכָּמָה",
						"it": "Consenso",
						"pl": "Zgoda",
						"sw": "Idhini",
						"tl": "Pahintulot",
						"vi": "Bằng lòng",
						"zh": "同意"
					},
					"value": "Consent"
				},
				"optionLabelPos": {
					"translations": {
						"ar": "يمين",
						"en": "right",
						"en-GB": "right",
						"en-US": "right",
						"es": "bien",
						"es-419": "bien",
						"es-ES": "bien",
						"he": "יָמִינָה",
						"it": "Giusto",
						"pl": "Prawidłowy",
						"sw": "kulia",
						"tl": "kanan",
						"vi": "Phải",
						"zh": "正确的"
					},
					"value": "right"
				},
				"options": {
					"translations": {
						"ar": "أنا موافق",
						"en": "I agree",
						"en-GB": "I agree",
						"en-US": "I agree",
						"es": "Estoy de acuerdo",
						"es-419": "Estoy de acuerdo",
						"es-ES": "Estoy de acuerdo",
						"he": "אני מסכים",
						"it": "Sono d'accordo",
						"pl": "Zgadzam się",
						"sw": "Nakubali",
						"tl": "Sumasang-ayon ako",
						"vi": "Tôi đồng ý",
						"zh": "我同意"
					},
					"value": "I agree"
				},
				"required": {
					"translations": {
						"ar": "حقيقي",
						"en": "true",
						"en-GB": "true",
						"en-US": "true",
						"es": "verdadero",
						"es-419": "verdadero",
						"es-ES": "verdadero",
						"he": "נָכוֹן",
						"it": "VERO",
						"pl": "PRAWDA",
						"sw": "kweli",
						"tl": "totoo",
						"vi": "ĐÚNG VẬY",
						"zh": "真的"
					},
					"value": "true"
				},
				"requiredCount": {
					"translations": {
						"ar": "1",
						"en": "1",
						"en-GB": "1",
						"en-US": "1",
						"es": "1",
						"es-419": "1",
						"es-ES": "1",
						"he": "1",
						"it": "1",
						"pl": "1",
						"sw": "1",
						"tl": "1",
						"vi": "1",
						"zh": "1"
					},
					"value": "1"
				},
				"type": {
					"translations": {
						"ar": "مربع الاختيار",
						"en": "checkbox",
						"en-GB": "checkbox",
						"en-US": "checkbox",
						"es": "caja",
						"es-419": "caja",
						"es-ES": "caja",
						"he": "תיבת הסימון",
						"it": "casella di controllo",
						"pl": "pole wyboru",
						"sw": "kisanduku cha kuteua",
						"tl": "checkbox",
						"vi": "hộp kiểm",
						"zh": "复选框"
					},
					"value": "checkbox"
				}
			}
		},
		"Section 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"ar": "معلومات الاتصال",
						"en": "Contact Information",
						"en-GB": "Contact Information",
						"en-US": "Contact Information",
						"es": "Información del contacto",
						"es-419": "Información del contacto",
						"es-ES": "Información del contacto",
						"he": "פרטי קשר",
						"it": "Informazioni sui contatti",
						"pl": "Informacje kontaktowe",
						"sw": "Taarifa za Mawasiliano",
						"tl": "Impormasyon sa Pakikipag-ugnayan",
						"vi": "Thông tin liên hệ",
						"zh": "联系信息"
					},
					"value": "Contact Information"
				},
				"questions": {
					"translations": {
						"ar": "السؤال 1+||+السؤال 2+||+السؤال 3+||+السؤال 4+||+السؤال 5",
						"en": "Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05",
						"en-GB": "Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05",
						"en-US": "Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05",
						"es": "Pregunta 01+||+Pregunta 02+||+Pregunta 03+||+Pregunta 04+||+Pregunta 05",
						"es-419": "Pregunta 01+||+Pregunta 02+||+Pregunta 03+||+Pregunta 04+||+Pregunta 05",
						"es-ES": "Pregunta 01+||+Pregunta 02+||+Pregunta 03+||+Pregunta 04+||+Pregunta 05",
						"he": "שאלה 01+||+שאלה 02+||+שאלה 03+||+שאלה 04+||+שאלה 05",
						"it": "Domanda 01+||+Domanda 02+||+Domanda 03+||+Domanda 04+||+Domanda 05",
						"pl": "Pytanie 01+||+Pytanie 02+||+Pytanie 03+||+Pytanie 04+||+Pytanie 05",
						"sw": "Swali la 01+||+Swali la 02+||+Swali la 03+||+Swali la 04+||+Swali la 05",
						"tl": "Tanong 01+||+Tanong 02+||+Tanong 03+||+Tanong 04+||+Tanong 05",
						"vi": "Câu hỏi 01+||+Câu hỏi 02+||+Câu hỏi 03+||+Câu hỏi 04+||+Câu hỏi 05",
						"zh": "问题 01+||+问题 02+||+问题 03+||+问题 04+||+问题 05"
					},
					"value": "Question 01+||+Question 02+||+Question 03+||+Question 04+||+Question 05+||+Question 06"
				},
				"type": {
					"translations": {
						"ar": "قسم",
						"en": "section",
						"en-GB": "section",
						"en-US": "section",
						"es": "sección",
						"es-419": "sección",
						"es-ES": "sección",
						"he": "סָעִיף",
						"it": "sezione",
						"pl": "sekcja",
						"sw": "sehemu",
						"tl": "seksyon",
						"vi": "phần",
						"zh": "部分"
					},
					"value": "section"
				}
			}
		},
		"general": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"confirmationMessage": {
					"translations": {
						"ar": "### شكرًا لتواصلك!\n\n\n<br />\n\nتم إرسال رسالتك بنجاح.\n\nسنتواصل معك قريبًا.\n\n<br />\n\n*هل تستخدم جهاز كمبيوتر عامًا؟ انقر على \"إعادة تعيين\" لمسح بياناتك.*",
						"en": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*",
						"en-GB": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*",
						"en-US": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*",
						"es": "### ¡Gracias por contactarnos!\n\n<br />\n\nSu mensaje se ha enviado correctamente.\n\nNos pondremos en contacto con usted en breve.\n\n<br />\n\n*¿Usa una computadora pública? Haga clic en \"Restablecer\" para borrar su información.*",
						"es-419": "### ¡Gracias por contactarnos!\n\n<br />\n\nSu mensaje se ha enviado correctamente.\n\nNos pondremos en contacto con usted en breve.\n\n<br />\n\n*¿Usa una computadora pública? Haga clic en \"Restablecer\" para borrar su información.*",
						"es-ES": "### ¡Gracias por contactarnos!\n\n<br />\n\nSu mensaje se ha enviado correctamente.\n\nNos pondremos en contacto con usted en breve.\n\n<br />\n\n*¿Usa una computadora pública? Haga clic en \"Restablecer\" para borrar su información.*",
						"he": "### תודה שפנית אליך!\n\n<br />\n\nהודעתך נשלחה בהצלחה. \nניצור איתך קשר בקרוב.\n\n<br />\n\n*משתמש במחשב ציבורי? לחץ על איפוס כדי לנקות את המידע שלך.*",
						"it": "### Grazie per averci contattato!\n\n<br />\n\nIl tuo messaggio è stato inviato correttamente.\nTi contatteremo a breve.\n\n<br />\n\n*Utilizzi un computer pubblico? Fai clic su \"Reimposta\" per cancellare le tue informazioni.*",
						"pl": "### Dziękujemy za kontakt!\n\n<br />\n\nTwoja wiadomość została pomyślnie wysłana.\nWkrótce się z Tobą skontaktujemy.\n\n<br />\n\n*Korzystasz z komputera publicznego? Kliknij „Resetuj”, aby wyczyścić swoje dane.*",
						"sw": "### Asante kwa kuwasiliana nawe!\n\n<br />\n\nUjumbe wako umewasilishwa kwa mafanikio. \nTutawasiliana nawe hivi karibuni.\n\n<br />\n\n*Unatumia kompyuta ya umma? Bonyeza \"reset\" ili kufuta taarifa zako.*",
						"tl": "### Salamat sa pakikipag-ugnayan!\n\n<br />\n\nMatagumpay na naisumite ang iyong mensahe. \nMakikipag-ugnayan kami sa iyo sa lalong madaling panahon.\n\n<br />\n\n*Gumagamit ng pampublikong computer? I-click ang reset para i-clear ang iyong impormasyon.*",
						"vi": "Cảm ơn bạn đã liên hệ!\n\n<br />\n\nTin nhắn của bạn đã được gửi thành công.\n\nChúng tôi sẽ liên hệ lại với bạn trong thời gian ngắn.\n\n<br />\n\n*Bạn đang sử dụng máy tính công cộng? Hãy nhấp vào \"Đặt lại\" để xóa thông tin của bạn.*",
						"zh": "### 感谢您的联系！\n\n<br />\n\n您的留言已成功提交。\n\n我们将尽快与您联系。\n\n<br />\n\n*如果您使用的是公共电脑，请点击“重置”按钮清除您的信息。*"
					},
					"value": "### Thank you for reaching out!\n\n<br />\n\nYour message has been submitted successfully.  \nWe will be in touch shortly.\n\n<br />\n\n*Using a public computer? Click reset to clear your information.*"
				},
				"formName": {
					"translations": {
						"ar": "اتصال",
						"en": "Contact",
						"en-GB": "Contact",
						"en-US": "Contact",
						"es": "Contacto",
						"es-419": "Contacto",
						"es-ES": "Contacto",
						"he": "מַגָע",
						"it": "Contatto",
						"pl": "Kontakt",
						"sw": "Mawasiliano",
						"tl": "Makipag-ugnayan",
						"vi": "Liên hệ",
						"zh": "接触"
					},
					"value": "Contact"
				}
			}
		},
		"index": 1,
		"order": {
			"permission": "Admin",
			"translations": {
				"ar": "2",
				"en": "2",
				"en-GB": "2",
				"en-US": "2",
				"es": "2",
				"es-419": "2",
				"es-ES": "2",
				"he": "2",
				"it": "2",
				"pl": "2",
				"sw": "2",
				"tl": "2",
				"vi": "2",
				"zh": "2"
			},
			"type": "TextInput",
			"value": "03"
		}
	},
	"Head": {
		"index": 2,
		"ldjson 01 Contact": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"@Context": {
					"translations": {
						"ar": "https://schema.org",
						"en": "https://schema.org",
						"en-GB": "https://schema.org",
						"en-US": "https://schema.org",
						"es": "https://schema.org",
						"es-419": "https://schema.org",
						"es-ES": "https://schema.org",
						"he": "https://schema.org",
						"it": "https://schema.org",
						"pl": "https://schema.org",
						"sw": "https://schema.org",
						"tl": "https://schema.org",
						"vi": "https://schema.org",
						"zh": "https://schema.org"
					},
					"value": "https://schema.org"
				},
				"@Id": {
					"translations": {
						"ar": "https://www.amberbellantelaw.com/contact/",
						"en": "https://www.amberbellantelaw.com/contact/",
						"en-GB": "https://www.amberbellantelaw.com/contact/",
						"en-US": "https://www.amberbellantelaw.com/contact/",
						"es": "https://www.amberbellantelaw.com/contact/",
						"es-419": "https://www.amberbellantelaw.com/contact/",
						"es-ES": "https://www.amberbellantelaw.com/contact/",
						"he": "https://www.amberbellantelaw.com/contact/",
						"it": "https://www.amberbellantelaw.com/contact/",
						"pl": "https://www.amberbellantelaw.com/contact/",
						"sw": "https://www.amberbellantlaw.com/contact/",
						"tl": "https://www.amberbellantelaw.com/contact/",
						"vi": "https://www.amberbellantelaw.com/contact/",
						"zh": "https://www.amberbellantelaw.com/contact/"
					},
					"value": "https://www.amberbellantelaw.com/contact/"
				},
				"@Type": {
					"translations": {
						"ar": "صفحة على الإنترنت",
						"en": "WebPage",
						"en-GB": "WebPage",
						"en-US": "WebPage",
						"es": "Página web",
						"es-419": "Página web",
						"es-ES": "Página web",
						"he": "דף אינטרנט",
						"it": "Pagina web",
						"pl": "Strona internetowa",
						"sw": "Ukurasa wa Wavuti",
						"tl": "Webpage",
						"vi": "Trang web",
						"zh": "网页"
					},
					"value": "WebPage"
				},
				"mainEntity.@Type": {
					"translations": {
						"ar": "صفحة الاتصال",
						"en": "ContactPage",
						"en-GB": "ContactPage",
						"en-US": "ContactPage",
						"es": "Página de contacto",
						"es-419": "Página de contacto",
						"es-ES": "Página de contacto",
						"he": "דף יצירת קשר",
						"it": "Pagina di contatto",
						"pl": "Strona kontaktowa",
						"sw": "Ukurasa wa Mawasiliano",
						"tl": "Pahina ng Pakikipag-ugnayan",
						"vi": "Trang Liên hệ",
						"zh": "联系页面"
					},
					"value": "ContactPage"
				},
				"mainEntity.name": {
					"translations": {
						"ar": "اتصل بنا",
						"en": "Contact Us",
						"en-GB": "Contact Us",
						"en-US": "Contact Us",
						"es": "Contáctanos",
						"es-419": "Contáctanos",
						"es-ES": "Contáctanos",
						"he": "צרו קשר",
						"it": "Contattaci",
						"pl": "Skontaktuj się z nami",
						"sw": "Wasiliana Nasi",
						"tl": "Makipag-ugnayan sa Amin",
						"vi": "Liên hệ với chúng tôi",
						"zh": "联系我们"
					},
					"value": "Contact Us"
				},
				"mainEntity.url": {
					"translations": {
						"ar": "https://www.amberbellantelaw.com/contact/",
						"en": "https://www.amberbellantelaw.com/contact/",
						"en-GB": "https://www.amberbellantelaw.com/contact/",
						"en-US": "https://www.amberbellantelaw.com/contact/",
						"es": "https://www.amberbellantelaw.com/contact/",
						"es-419": "https://www.amberbellantelaw.com/contact/",
						"es-ES": "https://www.amberbellantelaw.com/contact/",
						"he": "https://www.amberbellantelaw.com/contact/",
						"it": "https://www.amberbellantelaw.com/contact/",
						"pl": "https://www.amberbellantelaw.com/contact/",
						"sw": "https://www.amberbellantlaw.com/contact/",
						"tl": "https://www.amberbellantelaw.com/contact/",
						"vi": "https://www.amberbellantelaw.com/contact/",
						"zh": "https://www.amberbellantelaw.com/contact/"
					},
					"value": "https://www.amberbellantelaw.com/contact/"
				},
				"url": {
					"translations": {
						"ar": "https://www.amberbellantelaw.com/contact/",
						"en": "https://www.amberbellantelaw.com/contact/",
						"en-GB": "https://www.amberbellantelaw.com/contact/",
						"en-US": "https://www.amberbellantelaw.com/contact/",
						"es": "https://www.amberbellantelaw.com/contact/",
						"es-419": "https://www.amberbellantelaw.com/contact/",
						"es-ES": "https://www.amberbellantelaw.com/contact/",
						"he": "https://www.amberbellantelaw.com/contact/",
						"it": "https://www.amberbellantelaw.com/contact/",
						"pl": "https://www.amberbellantelaw.com/contact/",
						"sw": "https://www.amberbellantlaw.com/contact/",
						"tl": "https://www.amberbellantelaw.com/contact/",
						"vi": "https://www.amberbellantelaw.com/contact/",
						"zh": "https://www.amberbellantelaw.com/contact/"
					},
					"value": "https://www.amberbellantelaw.com/contact/"
				}
			}
		},
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "01"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "اتصل بنا",
				"en": "Contact Us",
				"en-GB": "Contact Us",
				"en-US": "Contact Us",
				"es": "Contáctanos",
				"es-419": "Contáctanos",
				"es-ES": "Contáctanos",
				"he": "צרו קשר",
				"it": "Contattaci",
				"pl": "Skontaktuj się z nami",
				"sw": "Wasiliana Nasi",
				"tl": "Makipag-ugnayan sa Amin",
				"vi": "Liên hệ với chúng tôi",
				"zh": "联系我们"
			},
			"type": "TextInput",
			"value": "Contact Us"
		}
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fcontact%20us%2FPageBanner%2FbgImage%2Fshutterstock_1092700045-first-frame.jpg?alt=media&token=1500da7b-8ac5-44e1-8b3a-9fed6234da63",
				"formattedSize": "212.48 KB",
				"height": 500,
				"name": "shutterstock_1092700045-first-frame.jpg",
				"path": "uploads/contact us/PageBanner/bgImage/shutterstock_1092700045-first-frame.jpg",
				"query": "?as=run",
				"size": 217582,
				"type": "image/jpeg",
				"updated": "2025-12-31T00:01:52.936Z",
				"width": 1600
			}
		},
		"bgVideo": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"ar": "لقطة جوية بانورامية مقرّبة لمبنى الكابيتول بولاية كاليفورنيا في سكرامنتو نهاراً. 4K",
						"en": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-GB": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"en-US": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K",
						"es": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-419": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"es-ES": "Primer plano de una toma aérea panorámica del Capitolio del Estado de California en Sacramento durante el día. 4K",
						"he": "צילום אווירי מקרוב של בניין הקפיטול של מדינת קליפורניה בסקרמנטו בשעות היום. 4K",
						"it": "Ripresa aerea panoramica ravvicinata del Campidoglio dello Stato della California a Sacramento durante il giorno. 4K",
						"pl": "Zbliżenie na Kapitol Stanowy Kalifornii w Sacramento z lotu ptaka w ciągu dnia. 4K",
						"sw": "Picha ya karibu ya angani ya Capitol ya Jimbo la California huko Sacramento wakati wa mchana. 4K",
						"tl": "Malapitang kuha mula sa himpapawid ng California State Capitol sa Sacramento noong araw. 4K",
						"vi": "Cảnh quay cận cảnh từ trên cao tòa nhà Quốc hội bang California ở Sacramento vào ban ngày. Độ phân giải 4K.",
						"zh": "白天，从空中拍摄的加州州议会大厦（位于萨克拉门托）的特写镜头。4K"
					},
					"value": "Close-up panning aerial shot of the California State Capitol in Sacramento at daytime. 4K"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/amber-bellante.firebasestorage.app/o/uploads%2Fcontact%20us%2FPageBanner%2FbgVideo%2Fshutterstock_1092700045.mp4?alt=media&token=0c63ec50-d744-46fc-ae56-a7b2bd515eea",
				"formattedSize": "4.28 MB",
				"height": 500,
				"name": "shutterstock_1092700045.mp4",
				"path": "uploads/contact us/PageBanner/bgVideo/shutterstock_1092700045.mp4",
				"query": "?as=run",
				"size": 4491390,
				"type": "video/mp4",
				"updated": "2025-12-31T00:02:16.346Z",
				"width": 1600
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "opacity-20 grayscale w-full"
				}
			}
		},
		"index": 3,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"ar": "اتصل بنا",
				"en": "Contact Us",
				"en-GB": "Contact Us",
				"en-US": "Contact Us",
				"es": "Contáctenos",
				"es-419": "Contáctenos",
				"es-ES": "Contáctenos",
				"he": "צרו קשר",
				"it": "Contattaci",
				"pl": "Skontaktuj się z nami",
				"sw": "Wasiliana Nasi",
				"tl": "Makipag-ugnayan sa Amin",
				"vi": "Liên hệ với chúng tôi",
				"zh": "联系我们"
			},
			"type": "TextInput",
			"value": "Contact Us"
		},
		"useMask": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		}
	}
}